import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 言語jsonファイルのimport
import translation_en from "./en.json";
import translation_ja from "./ja.json";

const isI18nDebug = (process.env.REACT_APP_I18_DEBUG === "true") ? true : false ;
const resources = {
  ja: {
    translation: translation_ja
  },
  en: {
    translation: translation_en
  }
};



  i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "ja", 
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    fallbackLng: "ja", // フォールバック言語。指定された言語ファイルがない場合などにこの言語が使用される
    returnEmptyString: true, // 空文字での定義を許可に
    //タグ認識を可能にする
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span', 'a'],
    },
    debug: isI18nDebug,
  });

  export default i18n;